import { init } from "@rematch/core";
import RedeemSM from "./redeem_sm";
import LoginSM from "./login_sm";
import ProfileSM from "./profile_sm";
import RewardSM from "./reward_sm";
import FinanceSM from "./finance_sm";
import SurveySM from "./survey_sm";
import RootSM from "./root_sm";
import QuizSM from "./quiz_sm";
import FeedsSM from "./feeds_sm";
import NewsSM from "./news_sm";
import AnnouncementSM from "./announcement_sm";
import EventSM from "./event_sm";
import PollingSM from "./polling_sm";
import createLoadingPlugin from "@rematch/loading";
import createPersistPlugin from "@rematch/persist";
import storage from "redux-persist/lib/storage";
import LeaderboardSM from "./leaderboard_sm";
import CommonSM from "./common_sm";
import CalendarSM from "./calendar_sm";
import CreateSM from "./create_sm";
import ReportSM from "./report_sm";
import ContactSM from "./contact_sm";
import BlockSM from "./block_sm";
import SnapReceiptSM from "./snap_receipt_sm";

const persistConfig = {
  key: "root",
  storage,
};

const store = init({
  models: {
    LoginSM,
    ProfileSM,
    RedeemSM,
    RewardSM,
    FinanceSM,
    SurveySM,
    RootSM,
    QuizSM,
    FeedsSM,
    NewsSM,
    AnnouncementSM,
    PollingSM,
    EventSM,
    LeaderboardSM,
    CommonSM,
    CalendarSM,
    CreateSM,
    ReportSM,
    ContactSM,
    BlockSM,
    SnapReceiptSM,
  },
  plugins: [
    createLoadingPlugin({ asNumber: false }),
    createPersistPlugin(persistConfig),
  ],
  redux: {
    devtoolOptions: {},
    rootReducers: { RESET_APP: () => undefined },
  },
});

export default store;
